let config = {
	SITE_NAME: 'Kiosk',
	// site_description: "Kiosk",
	// API_URL: "https://thanos-staging28.faasos.io/v3/",
	PROXY_URL: 'http://localhost:3001/',
	brandId: 134,
	clientSourceId: 13,
	clientOs: 'WebApp-Kiosk-EatSure',
	deviceType: 'mobile_web',


	spImagePathmobile: "https://assets.faasos.io/eatsure/production/surepoints_logo_mobile.svg",
	spImagePathdesktop: "https://assets.faasos.io/eatsure/production/surepoints_logo_desktop.svg",
};
export const sc_codes = {
	'staging': ['1111'],
	'production': ['2073',"2082","2091"]
}

export const DEFAULT_MSG = 'Something went wrong. Please try again.'
export const CUSTOMIZATION_FAIL_MSG= "Unable to fetch customizations."
export const NO_CUSTOMIZATIONS_AVAILABLE_MSG= "No customizations available."
export const UPDATE_CART_FAIL_MSG= "Unable to update cart."
export const UPSELL_DATA ="UPSELL_DATA"
export const DESSERTS = "desserts"
export const BEVERAGES = "beverages"
export const STARTERS = "starters"

export const constants = config;
